import { Component, OnInit } from '@angular/core'; 
import { AppConfigService } from './services/app-config.service';
import { CmsService } from './services/cms/cms.service';
import { CrmService } from './services/crm/crm.service';
import { PublicUtils } from '../app/utils/PublicUtils';
import { FormsUtils } from './utils/FormsUtils';
import swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'areandinaSena';
  path;
  ready:boolean = false;
  publicUtils = new PublicUtils();
  FormsUtils = new FormsUtils();
  content:any;
  programSena:any;
  faculties:any;
  types:any;
  constructor(private appConfig:AppConfigService, private cms:CmsService, private crm:CrmService){}
  ngOnInit(){ 
    this.appConfig.getConfig().subscribe(rps => {
        this.path = `${rps["sever"]}${rps["path"]}`;
        this.appConfig.config.next(rps);
        this.appConfig.config = this.appConfig.config["_value"];
        this.appConfig.getConfigData().subscribe(rpsC=>{
           let landing:any = this.publicUtils.getLP(rpsC["data"][0]["data"]);
           landing.configForm = this.publicUtils.getLP(rpsC["data"][1]["data"]);
           this.appConfig.landing.next(landing);
           this.getContent();
        })

        
         this.appConfig.datalayer.next(rps);
         this.appConfig.datalayer = this.appConfig.datalayer["_value"];
         this.appConfig.getConfigDatalayer().subscribe(rpsC=>{
          let datalayer = this.publicUtils.getDatalayer(rpsC["data"]);
          window["infoDataLayer"] = datalayer   
         })

      },
      err => {
        //swal.fire('error!', 'no se pudo conectar al servicio', 'error');
        this.appConfig.config.next(err);
    });
  }

  getContent(){
    this.cms.getContents().subscribe( rps => {
      this.content = this.publicUtils.orderData(rps["data"][0].data);
      this.crm.getPrograms("FUAA").subscribe(data => {
        let programs = this.publicUtils.orderPrograms(rps["data"][1].data,data["programs"]);
        let programSena = this.publicUtils.orderProgramsSena(rps["data"][2].data,data["programs"],programs);
        this.appConfig.programs.next(programs);    
        //this.types = this.publicUtils.orderTypes(programs);
        this.types = this.FormsUtils.orderBy(programSena,"nameSena");
        this.faculties = this.publicUtils.orderFaculty(programs);
        if(this.publicUtils.getURLParam("utm_code") != null){
          this.loadContentProgram(this.publicUtils.getURLParam("utm_code"));
        }
        this.ready = true;
      },err => {
        console.log(err);
      });
    },
    err => {
      //swal.fire('Hey user!', err, 'error');
    });
  }

  getContentDL(){
    this.cms.getContentsDL().subscribe( rps => {
      this.content = this.publicUtils.orderData(rps["data"][0].data);
      setTimeout(function(){window["init"]();},2000)
      this.crm.getPrograms("FUAA").subscribe(data => {
        let programs = this.publicUtils.orderPrograms(rps["data"][1].data,data["programs"]);
        this.appConfig.programs.next(programs);    
        this.types = this.publicUtils.orderTypes(programs);
        this.faculties = this.publicUtils.orderFaculty(programs);
        if(this.publicUtils.getURLParam("utm_code") != null){
          this.loadContentProgram(this.publicUtils.getURLParam("utm_code"));
        }
        this.ready = true;
      },err => {
        console.log(err);
      });
    },
    err => {
      //swal.fire('Hey user!', err, 'error');
    });
  }

  loadContentProgram($data){ 
    if(typeof $data != "object"){
      let progs = this.appConfig.programs["_value"];
      let centinela = false;
      for(let i =0; i < progs.length && centinela == false; i++){
        if($data == progs[i].code){
          centinela = true;
          if(progs[i].Imagen_BANNER != "N/A" && progs[i].Imagen_BANNER != ""){
            this.content.BANNER.Imagen = progs[i].Imagen_BANNER;
          }
        }
      }
    }
  }
} 
